import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({

    // Barra de opcion

    dir: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        margin: "auto"
    },
    back_home: {
        paddingLeft: "10px",
        maxWidth: "20px",
    },
    back_home_container: {
        maxWidth: '60px',
        minWidth: '60px',
        maxHeight: '35px',
        minHeight: '35px'
    },
    title: {
        color: "white",
        filter: "drop-shadow(3px 3px 2px #000000c4)",
        margin: "20px"
    },


    // - Barra de opcion

    main_section: {
        display: "flex",
        flexDirection: "column",

    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        backgroundColor: "#03040ac4",
        display: "flex",
        flexDirection: "column"
    },
    paper: {
        width: "900px",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "auto"
    },
    preview: {
        maxWidth: "650px",
        margin: "25px",
        pointerEvents: "none",
        userSelect: "none",
    },
    field: {
        width: "100%",
        maxWidth: "650px",
    },
    text_select: {
        margin: "20px auto",
        width: "150px",
        textAlign: "center",
    },

    teclado: {
        "& button": {
            padding: "14px 0px",
            margin: "2px 1px",
            border: "1px solid rgb(145, 145, 145)",
            boxShadow: "3px 7px 2px #888888"
        },

    },
    fila_2: {
        paddingLeft: "20px",
    },
    fila_3: {
        paddingLeft: "40px",
    },
    fila_4: {
        marginTop: "20px",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        justifyContent: "center",
        "& Button": {
            width: "25px",
            borderRadius: "15px",
            border: "2px solid rgb(179, 131, 29)",
            backgroundColor: "rgb(245, 213, 146)",
        },
    },
    spacer: {
        width: "25px",
    },

    dedo_1: {
        height: "50px",
    },
    dedo_2: {
        height: "70px",
    },
    dedo_3: {
        height: "80px",
    },
    dedo_4: {
        height: "70px",
    },
    dedo_5: {
        height: "30px",
    },
}));
